export enum ParamType {
    STRING= 'string',
    DATE_RANGE='date_range',
    NUMBER='number',
    OPTIONS='options',
    ARRAY='array'
}
